<script setup lang="ts">
import LoadingModal from "@/components/LoadingModal.vue";
import StyledButton from "@/components/StyledButton.vue";
import StyledTable from "@/components/StyledTable.vue";
import StyledTextarea from "@/components/StyledTextarea.vue";
import { Hotel } from "@/internal/modules/providers/interfaces/Hotel";
import { reactive } from "vue";
import { useToast } from "vue-toastification";
import useHotelComments from "../composables/useHotelComments";

interface Props {
  hotel: Hotel;
}

const props = defineProps<Props>();
const toast = useToast();

const {
  data,
  isLoading,
  refetch: refetchHotelComments,
  createCommentMutationAsync,
  createCommentMutationLoading,
} = useHotelComments({
  immediate: true,
  params: {
    id: props.hotel.id,
  },
});

const form = reactive({
  comment: "",
});

const handleCreateComment = async () => {
  if (!form.comment) {
    toast.error("El comentario es requerido");
    return;
  }

  await createCommentMutationAsync({
    id: props.hotel.id,
    comment: form.comment,
  });

  form.comment = "";
  refetchHotelComments();
};

const headers = {
  createdAt: "Fecha",
  creatorName: "Usuario",
  commentary: "Comentario",
};
</script>

<template>
  <template v-if="!isLoading">
    <StyledTable
      title="Comentarios generales"
      create-toggle-title="Agregar comentario"
      on-delete-title="¿Está seguro de eliminar este comentario?"
      custom-grid-class="grid gap-x-2 grid-cols-[repeat(6,_minmax(144px,_1fr))]"
      :headers="headers"
      :entries="data?.data || []"
      :on-create="handleCreateComment"
      :show-save-button="false"
    >
      <template #form>
        <StyledTextarea
          class="!w-full"
          v-model="form.comment"
          label="Comentario"
          placeholder="¿Qué ha sucedido?"
        />

        <StyledButton
          class="bg-[#253C70] text-white h-fit ml-auto !p-[0.65rem] !py-[0.25rem]"
          :loading="createCommentMutationLoading"
          :disabled="createCommentMutationLoading"
        >
          <span class="material-symbols-outlined text-2xl"> save </span>
          <p>Guardar</p>
        </StyledButton>
      </template>

      <template #entry="{ key, entryField }">
        <span :class="[key == 'commentary' && 'col-span-3']">{{
          entryField
        }}</span>
      </template>
    </StyledTable>
  </template>
  <LoadingModal :when="isLoading" />
</template>
